// Mirrors uzai-backend/src/main/models/Integration.ts.
// ObjectIds and dates are exposed as strings on the wire.

export enum IntegrationKind {
  WEBSITE = 'WEBSITE',
}

// Non-implemented kinds shown as disabled cards on the list page.
export enum IntegrationTypeComingsoon {
  MAIL = 'MAIL',
  INVOICING = 'INVOICING',
  DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
  SOCIAL_NETWORK = 'SOCIAL_NETWORK',
}

export interface Integration {
  _id: string;
  name: string;
  organizationId: string;
  owner: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar?: string;
  };
  kind: IntegrationKind;
  createdAt?: string;
  updatedAt?: string;
}
